export const config = {
  apiUrl:'https://pk.island-ukraine.com/api/',
  printUrl:'https://pk.island-ukraine.com/printforms/',
  intervalDataUpdate: 5000,
  scanCodeMin: 1,
  scanCodeMax: 1000,
  debugScan: true,
  enableArmDisplay2: true
};
